<template>
  <div class="select-package">
        <!-- <app-header @on-click="goBack" :title="$t('packages.package_list')" /> -->
        <!-- <div class="home-package" v-if="Module_MyFlow">
            <div class="home-package-bg"></div>
            <div class="home-package-header">
                <span class="title">{{ $t('home.my_flow') }}</span>
                <div class="manage-package" @click="fData.goToMyFlow" >{{ $t('home.more') }} </div>
            </div>
            <div class="home-package-con" v-if="fData.packageUseDetail">
                <h3 class="package-name van-multi-ellipsis--l2 mt10">{{ fData.packageUseDetail.goodsName }}</h3>
                <p v-if="!fData.packageUseDetail.extendValVos || !fData.packageUseDetail.a_getValue_hideFlowSize || fData.packageUseDetail.a_getValue_hideFlowSize && fData.packageUseDetail.a_getValue_hideFlowSize != '1' " class="mt10">{{fData.packageUseDetail.a_surplusFlow.type == 'DISC' ? $t('order.remainingHighFlow') : $t("order.remainingFlow")}}: {{fData.packageUseDetail.a_surplusFlow.remainFlow | filterFlow}}</p>
                <p class="mt10" v-if="fData.packageUseDetail.status !== 'NOT_ACTIVATED' && fData.packageUseDetail.isUseActive">{{fData.packageUseDetail.a_activeTime.name}}: {{fData.packageUseDetail.a_activeTime.time}}</p>
                <span class="state-tips">{{ fData.packageUseDetail.status !== 'NOT_ACTIVATED' && fData.packageUseDetail.isUseActive ? $t('home.package_useing') : $t('home.unused') }}</span>
            </div>
            <div class="home-package-no-con" v-else>
                <span v-if="fData.isShowNoData">{{ $t('home.no_data_available') }}</span>
            </div>
        </div>
        <div class="my-nav-bar" :class="{
            'grid-columns': (Module_ChargeCode + Module_Coupons_Page) === 1
        }" v-if="Module_ChargeCode || Module_Coupons_Page">

            <div class="line" v-if="isShowNavLine"/>
            <div class="item" @click="fData.goToCharge" v-if="Module_ChargeCode">
                <img src="../../../assets/imgs/home/charge-icon.png" />
                <div class="name">{{ $t('home.charge_code') }}</div>
            </div>
            <div class="item module-coupons" @click="fData.goToCoupon" v-if="Module_Coupons_Page">
                <div class="coupons-img-count">
                    <img src="../../../assets/imgs/home/coupon.png" />
                    <span v-if="couponCount" class="coupons-count">{{couponCount}}</span>
                </div>
                <div class="name">{{ $t('home.coupons') }}</div>
            </div>
        </div> -->
        <template v-if="packageGroupList && packageGroupList.length">
            <div class="select-package-con">
                <!-- <div class="select-tabs-con">
                    <van-tabs 
                        :class="'van-tabs-con'" 
                        :active="activeTab" 
                        swipe-threshold="3" 
                        swipeable 
                        animated 
                        color="#4361EE" 
                        title-active-color="#4361ee" 
                        title-inactive-color="#000" 
                        line-width="10%" 
                        line-height="0.2em"
                        v-if="packageGroupList && packageGroupList.length"
                    >
                        <van-tab :title="$t('select_package.title')" :name="'selected'"></van-tab>
                    </van-tabs>
                </div> -->
                <div class="select-package-item-con">
                    <p class="type-title">{{$t('select_package.type')}}</p>
                    <div class="package-type-item-con">
                        <span class="package-type-item" v-for="tab in packageGroupList" :key="tab.value" :class="selectValueList[0] === tab.value ? 'active' : ''" @click="handlerSelectValue(tab,0)">
                            {{ tab.label }}
                        </span>
                    </div>
                    <p class="type-title">{{$t('select_package.flow')}}</p>
                        <div v-for="pack in handlerValueList(0)" :key="pack.value">
                            <div class="package-type-pack-con">
                                <div class="package-type-pack-title">
                                    {{ pack.label }}
                                    <img class="package-bg-img" src="@/assets/imgs/packages/package-type-bg.png" alt="">
                                </div>
                            </div>
                            <div class="flow-data" >
                                <span class="package-type-item" v-for="data in pack.list" :key="data.value"  :class="selectValueList[1] === pack.value && selectValueList[2] === data.value ? 'active' : ''" @click="handlerSelectValue(data,2,pack)">
                                    {{ data.label }}
                                </span>
                            </div>
                        </div>
                    <p class="type-title">{{ selectValueList[1] === 'PKAG' ? $t('select_package.time') : $t('select_package.period') }}</p>
                        <div class="package-list">
                            <div class="package-item" v-for="pack in handlerValueList(2)" :key="pack.goodsCode" :class="selectValueList[3] === pack.goodsCode? 'active' : ''" @click="handlerSelectValue(pack,3)">
                                <span class="use_coupon_tips" v-show="pack.promotionCode">{{ $t('packages.special_offer') }}</span>
                                <div class="package-time">{{pack.showPeriod}}</div>
                                <div class="package-price">{{pack.goodsPriceText}}</div>
                                <div class="package-approx" v-show="selectValueList[0] !== 'ROAMING'">{{pack.showBottomtips }}</div>
                                <div class="package-approx" v-show="selectValueList[0] === 'ROAMING'">{{pack.areaName}} </div>
                            </div>
                        </div>
                    <template v-if="selectValue.categoryCode === 'LXCX' && selectValue.payAgreeFlag == '1'" >
                        <p class="type-title">{{$t('select_package.auto_debit')}}</p>
                            <div class="auto-deduction-tips">
                                <div v-html="selectValue.continue_html"></div>
                                <div class="service-items">
                                    {{$t('settlement_Read')}}《<a :href="CheckautopayRegulation.url"  target="_blank" >{{$t('settlement_Autopay_service_regulation')}}</a>》
                                </div>
                            </div>
                    </template>

                    <div class="package-details" v-show="selectValue.showUserRemark || selectValue.showUserDetail || selectValue.showAreaList">
                        <div class="title">{{$t('select_package.detail')}}</div>

                        <div class="package-detail-item" v-show="selectValue.showUserRemark">
                            <span class="tip"></span>
                            {{$t('select_package.carrier')}}
                        </div>
                        <div v-show="selectValue.showUserRemark" class="package-detail-content">{{ selectValue.showUserRemark }}</div>

                        <div class="package-detail-item flex-between" v-show="selectValue.showAreaList">
                            <div>
                                <span class="tip"></span>
                                {{$t('select_package.country')}}
                            </div>
                            <van-icon :name="iconName" class="toggle-btn" @click="showMore = !showMore" />
                        </div>
                        <div v-show="selectValue.showAreaList" class="package-detail-content" :class="{'van-multi-ellipsis--l3': !showMore}">{{selectValue.showAreaList}}</div>

                        <div class="package-detail-item flex-between" v-show="selectValue.showUserDetail">
                            <div>
                                <span class="tip"></span>
                                {{$t('select_package.notice')}}
                            </div>
                            <van-icon :name="userDetailShowMore ? 'arrow-up': 'arrow-down'" class="toggle-btn" @click="userDetailShowMore = !userDetailShowMore" />
                        </div>
                        <div v-show="selectValue.showUserDetail" class="package-detail-content" :class="{'van-multi-ellipsis--l3': !userDetailShowMore}" v-html="selectValue.showUserDetail"></div>
                    </div>
                </div>
            </div>
            <div class="pay-btn-con">
                <div class="pay-price">{{selectValue.goodsPriceText}}</div>
                <div class="pay-btn" @click="gotoPay">{{$t('packages.detail.pay')}}</div>
            </div>
        </template>

        <div class="no-data" v-else>
            <img src="@/assets/imgs/login/noCoupons.png" alt="">
            <span class="tips-noData">{{$t('coupons.no_data')}}</span>
        </div>
  </div>
</template>

<script>
import { keepTwodecimalFixed, isAndroid } from '@/utils/util';
import cookie from '@/utils/cookie';
import checkProjectConfig from '@/lib/checkProjectConfig';
import { Tab, Tabs } from 'vant';
import { deepClone } from "@/utils/util";
const autopayRegulation_url = {
    'zh-CN': 'autopayRegulation_url_zh_cn',
    'zh-TW': 'autopayRegulation_url_zh_tw',
    'en-US': 'autopayRegulation_url_en',
    'tr-TR': 'autopayRegulation_url_tr',
    'ja-JP': 'autopayRegulation_url_ja',
    'vi-VN': 'autopayRegulation_url_vi',
    'th-TH': 'autopayRegulation_url_th',
    'de-DE': 'autopayRegulation_url_de',
    'pt-PT': 'autopayRegulation_url_pt',
    'es-ES': 'autopayRegulation_url_es',
    'fr-FR': 'autopayRegulation_url_fr',
    'it-IT': 'autopayRegulation_url_it',
    'in-ID': 'autopayRegulation_url_in',
    'ru-RU': 'autopayRegulation_url_ru',
    'ar-AE': 'autopayRegulation_url_ar',
    'ko-KR': 'autopayRegulation_url_ko',
    'pl-PL': 'autopayRegulation_url_pl',
    'ms-MY': 'autopayRegulation_url_ms',
    'uz-UZ': 'autopayRegulation_url_uz',
    'nl-NL': 'autopayRegulation_url_nl',
    'sv-SE': 'autopayRegulation_url_sv',
    'fi-FI': 'autopayRegulation_url_fi',
    'da-DK': 'autopayRegulation_url_da',
    'nb-NO': 'autopayRegulation_url_nb',
    'el-GR': 'autopayRegulation_url_el',
    'hu-HU': 'autopayRegulation_url_hu',
    'bg-BG': 'autopayRegulation_url_bg',
    'ro-RO': 'autopayRegulation_url_ro',
    'cs-CZ': 'autopayRegulation_url_cs',
    'sk-SK': 'autopayRegulation_url_sk',
    'sl-SI': 'autopayRegulation_url_sl',
    'sq-AL': 'autopayRegulation_url_sq',
    'hr-HR': 'autopayRegulation_url_hr',
    'lt-LT': 'autopayRegulation_url_lt',
    'lv-LV': 'autopayRegulation_url_lv',
    'et-EE': 'autopayRegulation_url_et',
    'is-IS': 'autopayRegulation_url_is',
    'km-KH': 'autopayRegulation_url_km',
    'lo-LA': 'autopayRegulation_url_lo',
};
export default {
    name: 'SelectPackage',
    props: {
        fData: {
            type: Object,
            default: () => ({})
        },
        allTagList: {
            type: Array,
            default: () => []
        },
        allPackageList: {
            type: Array,
            default: () => []
        },
        regionList: {
            type: Array,
            default: () => []
        },
    },
    components: {
        vanTabs: Tabs,
        vanTab: Tab,
    },
    computed: {
        iconName() {
            return this.showMore ? 'arrow-up': 'arrow-down'
        },
        Module_MyFlow:function(){
            return checkProjectConfig.setAppThat(this).checkValue("Module_MyFlow",true);
        },
        Module_ChargeCode:function(){
            return checkProjectConfig.setAppThat(this).checkValue("Module_ChargeCode",true);
        },
        Module_Coupons_Page:function(){
            return checkProjectConfig.setAppThat(this).checkValue("Module_Coupons_Page",false);
        },
        Module_HomeComeBack:function(){
            return checkProjectConfig.setAppThat(this).checkValue("Module_HomeComeBack",true);
        },
        couponCount() {
            // return this.couponList.length
        },
        isShowNavLine() {
            return (this.Module_ChargeCode + this.Module_Coupons_Page) >= 2;
        },
    },
    data() {
        return {
            activeTab: 'selected',
            // regionList:[],
            // allTagList: [],
            packageGroupList: [],
            selectValueList: [],
            selectValue: {},
            CheckautopayRegulation:{
                url:this.$APP_CONFIG[autopayRegulation_url[cookie.getCookie('langType')]],
            },
            showMore: false,
            userDetailShowMore: false,
        }
    },
    watch: {
        allPackageList: {
            handler(newVal) {
                this.setup();
                this.getLocalPackageList();
            },
            deep: true,
            immediate: true,   
        },
    },
    mounted() {
        // this.setup();
    },
    methods:{
        goBack() {
            this.$router.go(-1);
        },
        // 设置单个tab靠左
        setOneTabLeft() {
            setTimeout(() => {
                const elementA = document.querySelector('.van-tab');
                const elementB = document.querySelector('.van-tab__text');
                const elementC = document.querySelector('.van-tabs__line');
                let left = elementA.offsetLeft + elementB.offsetLeft + (elementB.offsetWidth / 2) - (elementC.offsetWidth / 2);
                elementC.style.transform = `translateX(${left}px)`;
            },0)
        },
        async setup() {
            let placeCode = JSON.parse( sessionStorage.getItem('urlData') || '{}').placeCode  ||
                            JSON.parse( sessionStorage.getItem('ProjectConfigDetailData') || '{}').placeCode;
            if(placeCode) {
                this.placeCode = placeCode;
            }
            this.packageGroupList = [];
            // await this.getCouponsList();
            // this.getPackageTagList(() => {
            //     this.getHotRegion(() => {
            //         // if(this.allTagList && this.allTagList.length === 1 && this.allTagList[0].tagKey === 'ROAMING'){
            //         //     this.getRoamingPackageList();
            //         // } else {
                        // this.getLocalPackageList();
            //         // }
            //     });
            // });
        },
        // 获取优惠券列表
        async getCouponsList() {
                let sessionStorageUrlData = JSON.parse(sessionStorage.urlData || '{}') || {};
                let res  = await this.$http
                .post({
                    url: "/bss/app/promotion/queryPromotionInst",
                    data: {
                        currentPage: 1,
                        perPageCount: 1000,
                        loginCustomerId: sessionStorageUrlData.loginCustomerId,
                        status:'AVAILABLE'
                    },
                })
                let data_CouponList = (res?.data?.dataList || []).map(item => {
                    return {
                        goodsList: item.goodsList,
                        promotionMode: item.promotionMode,
                        promotionCode: item.promotionCode,
                        fullCut: item.fullCut,
                        quota: item.quota,
                    }
                })
                sessionStorage.setItem('data-couponList', JSON.stringify(data_CouponList));
        },
        // 去支付
        gotoPay() {
            let isLxcx;
            if(this.selectValue.categoryCode === 'LXCX' && this.selectValue.payAgreeFlag == '1'){
                isLxcx = true;
            } else {
                isLxcx = false;
            }
            let data_package = {
                selectPackage:this.selectValue.goodsId,
                isLxcx:isLxcx,
                data:{}
            }
            data_package.data[this.selectValue.goodsId] = JSON.stringify(this.selectValue);
            sessionStorage.setItem('data_info',JSON.stringify(data_package));
            if(this.selectValue.promotionActivityCode){
                let detail = {
                    ...this.selectValue,
                    PromotionValue: [
                        {
                            show_Promotion_name: this.selectValue?.actTags[this.selectValue.promotionActivityCode] || '',
                        }
                    ]
                }
                sessionStorage.setItem('data_promotion',JSON.stringify(detail));
            } else {
                sessionStorage.removeItem('data_promotion');
            }
            this.$router.push({ 
                name: 'settlement',
                query: { 
                    goodsCode: this.selectValue.goodsCode,
                    categoryCode: this.selectValue.categoryCode,
                    goodsType: this.selectValue.goodsType,
                    souce: '选择套餐页面',
                    promotionCode: this.selectValue.promotionCode || '',
                    quantity: 1,
                } 
            });

            // 神策点击事件 - 购买套餐 - Web
            this.$sensors.track('WebSelectPackageBuyClick', {
                data_package_code:this.selectValue.goodsCode,
                data_package_name:this.selectValue.goodsName,
                data_package_type: (this.selectValue.iso2List.length > 1 || this.selectValue.iso2List[0] == 'ALL') ? '跨区域流量包' : '地区流量包',
                data_package_amount:+this.selectValue.goodsPriceNum,
                monetary_unit:this.selectValue.currencyType,
            });
        },
        // 点击选择套餐
        handlerSelectValue(item,level,pack) {
            if(level === 3){
                this.selectValueList.splice(level, 1, item.goodsCode);
                this.selectValue = item;
                return;
            }
            let length = this.selectValueList.length;
            for (let index = 0; index < length; index++) {
                
                if(index === level){
                    this.selectValueList.splice(index,1,item.value);
                }

                if(index > level){
                    let value = item.list[0].value;
                    if(index === 2){
                        if(level === 0){
                            value = item.list[0].list[0].value;
                        }
                        if(level === 1){
                            value = item.list[0].value;
                        }
                    }
                    if(index === 3){
                        if(level === 0){
                            value = item.list[0].list[0].list[0].goodsCode;
                        }
                        if(level === 1){
                            value = item.list[0].list[0].goodsCode;
                        }
                        if(level === 2){
                            value = item.list[0].goodsCode;
                        }
                    }
                    this.selectValueList.splice(index,1,value);
                }
            }
            if(level === 0){
                this.selectValue = item.list[0].list[0].list[0];
            }
            if(level === 1){
                this.selectValue = item.list[0].list[0];
            }
            if(level === 2){
                this.selectValueList.splice(1,1,pack.value)
                this.selectValue = item.list[0];
            }
        },
        // 获取对应数据
        handlerValueList(level) {
            if(!this.selectValueList?.length) return [];
            // 深度优先递归查找
            let that = this;
            function findNode(currentData, currentPathIndex) {
                // 如果已经到路径末尾，说明找到了目标节点
                if (currentPathIndex >= level) {
                // 在当前层级中查找匹配的节点
                
                    const target = currentData.find(item => item.value === that.selectValueList[currentPathIndex]);
                    return target ? target.list : [];
                }
                
                // 查找当前层级的匹配节点
                const currentNode = currentData.find(item => item.value === that.selectValueList[currentPathIndex]);
                
                if (!currentNode || !currentNode.list) {
                    return []; // 路径不匹配或节点没有list
                }
                
                // 继续深入下一层查找
                return findNode(currentNode.list, currentPathIndex + 1);
            }
            
            return findNode(this.packageGroupList, 0);
        },
        // 查询套餐标签
        getPackageTagList(success) {
            let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
            if(!urlData.loginCustomerId) return;
            this.$http.post({
                url: 'bss/app/noauth/QueryOfferTag',
                data: {
                    ignoreOfferTagFlag: 1,
                    offerTagFlag:0,
                    offerTagMethod:1,
                }
            })
            .then((res) => {
                if(res.data && res.data.length){
                    this.allTagList = res.data;
                    success && success();
                } else {
                    // this.getLocalPackageList(); // 如果没有标签数据，则直接查询本地流量套餐
                }
            })
            .catch((err) => {
                console.log(err);
            });
        },
        // 查询热门大洲套餐
        async getHotRegion(success) {
            let typeCode ;
            let typeCode_mvnoCode = JSON.parse(sessionStorage.getItem('urlData') || '{}').mvnoCode;

            if(typeCode_mvnoCode){
                typeCode =  `HOTREGION_${typeCode_mvnoCode.toUpperCase()}`;
                try {
                    let res = await this.$http.post({
                        url: '/bss/app/noauth/dictionary/QueryDictionaryValueListInfo',
                        data: {                      
                            type: typeCode, 
                        }
                    })
                    // Africa - UN60 、Oceania - UN29、 Asia - UN50、European - UN52、SouthAmerica - UN57、 NorthAmerica - UN57
                    this.regionList = res.data || [];
                    success && success();
                } catch (error) {
                    success && success();
                }
            }
        },
        getRoamingPackageList(){
            let urlData = JSON.parse(sessionStorage.urlData) || {};
            let channelType = this.$APP_CONFIG.request.channelType;
            let extendAttrs = this.regionList.map(item => item.key);
            this.$http.post({
                url: '/bss/app/noauth/QueryOfferList',
                data: {                        
                    channelType,
                    queryLimitFlag: true,
                    queryPromotionFlag: true,
                    sortFlag: 1,
                    showFlowFlag:1,
                    areaFlag: 'ROAMING', // 全球漫游
                    params: {
                        queryVipDayFlag: true
                    },
                    buyTerminalType:urlData.terminalType,
                    goodsExtendAttrs:["detailRemark","hideFlowSize",...extendAttrs] // detailRemark 获取扩展属性
                }
            }).then(res => {            
                let tmpList = res.data.dataList || [];
                tmpList = tmpList.length > 0 ? this.initLocalPackageData(tmpList) : [];

                // // 按套餐标签进行分类
                // tmpList = tmpList.map(item => ({...item, attrValueList: [] }));  
                // tmpList.forEach(item => {
                //     if(item.extendValVos && item.extendValVos.length){
                //         item.extendValVos.forEach(val => {
                //             item.attrValueList = [...item.attrValueList, ...val.attrValueList];
                //         });
                //     }
                // });

                tmpList.forEach(item => {
                    if(item.extendValVos && item.extendValVos.length){
                        item.extendValVos.forEach(extend => {
                            this.regionList.forEach(region => {
                                if(extend.attrCode === region.key){
                                    item.areaName = region.value;
                                }
                            });
                        })
                    }
                })

                // 分类套餐
                this.allTagList.some(item => {
                    if(item.tagKey === 'ROAMING' && tmpList.length){
                        let list = this.handlerClassify(tmpList);
                        this.packageGroupList.push({
                            value: item.tagKey,
                            label: item.tagName,
                            list,
                        });
                        return true;
                    }
                })

                this.selectValueList[0] =  this.packageGroupList[0].value;
                this.selectValueList[1] =  this.packageGroupList[0].list[0].value;
                this.selectValueList[2] =  this.packageGroupList[0].list[0].list[0].value;
                this.selectValueList[3] =  this.packageGroupList[0].list[0].list[0].list[0].goodsCode;
                this.selectValue = this.packageGroupList[0].list[0].list[0].list[0];
                
                // this.setOneTabLeft();
            }).catch(err => {
                this.$toast(err);
                console.log(err);
                
            });
        },
        getLocalPackageList(){
            let urlData = JSON.parse(sessionStorage.urlData) || {};
            let channelType = this.$APP_CONFIG.request.channelType,
                mcc = this.placeCode;
            let extendAttrs = this.regionList.map(item => item.key);
            // this.$http.post({
            //     url: '/bss/app/noauth/QueryOfferList',
            //     data: {                        
            //         channelType,
            //         // mcc,
            //         queryLimitFlag: true,
            //         queryPromotionFlag: true,
            //         sortFlag: 1,
            //         showFlowFlag:1,
            //         // areaFlag: 'LOCAL', // 保留原来没有extendValueMap的逻辑，查询本地流量套餐
            //         params: {
            //             queryVipDayFlag: true
            //         },
            //         buyTerminalType:urlData.terminalType,
            //         goodsExtendAttrs:["detailRemark","hideFlowSize",...extendAttrs] // detailRemark 获取扩展属性
            //     }
            // }).then(res => {            
                let tmpList = deepClone(this.allPackageList) || [];
                tmpList = tmpList.length > 0 ? this.initLocalPackageData(tmpList) : [];
                if(!tmpList || !tmpList.length) return;
                // // 按套餐标签进行分类
                // tmpList = tmpList.map(item => ({...item, attrValueList: [] }));  
                // tmpList.forEach(item => {
                //     if(item.extendValVos && item.extendValVos.length){
                //         item.extendValVos.forEach(val => {
                //             item.attrValueList = [...item.attrValueList, ...val.attrValueList];
                //         });
                //     }
                // });

                let RoamingPackageList = tmpList.filter(item => {
                    return item?.attrMap?.areaFlag === 'ROAMING' || item?.attrMap?.areaFlag === 'ALL';
                })

                // let localPackageList = tmpList.filter(item => {
                //     return (item?.attrMap?.areaFlag === 'LOCAL' || item?.attrMap?.areaFlag === 'ALL') && !item.multiRegionFlag && item.iso2List.includes(mcc);
                // });

                let regionPackageList = tmpList.filter(item => {
                    return (item?.attrMap?.areaFlag === 'LOCAL' || item?.attrMap?.areaFlag === 'ALL') && (item.iso2List.includes(mcc) || item.iso2List.includes('ALL'));
                });

                let localPackageList = regionPackageList.filter(item => {
                    let attr = item.extendValVos?.find(val => extendAttrs.includes(val.attrCode)) || {};

                    return !attr?.attrCode
                });

                // 分类套餐
                this.allTagList.some(item => {
                    if(item.tagKey === 'LOCAL' && localPackageList.length){
                        let list = this.handlerClassify(localPackageList);
                        this.packageGroupList.push({
                            value: item.tagKey,
                            label: sessionStorage.getItem('registerCountryName') || item.tagName,
                            list,
                        });
                        return true;
                    }
                })

                this.regionList.forEach(region => {
                    let list = regionPackageList.filter(pkg => {
                        if(pkg.extendValVos && pkg.extendValVos.length){
                            return pkg.extendValVos.some(extend => extend.attrCode === region.key)
                        }
                    });
                    if(list.length){
                        this.packageGroupList.push({
                            value: region.key,
                            label: region.value,
                            list: this.handlerClassify(list),
                        });
                    }
                });
                
                // let areaList = regionPackageList.filter(pkg => {
                //     if(!pkg.extendValVos || !pkg.extendValVos.length ) return true;
                // });

                // if(areaList.length){
                //     this.packageGroupList.push({
                //         value: 'AREA',
                //         label: this.$t('packages.regional_data'),
                //         list: this.handlerClassify(areaList),
                //     });
                // }

                // 如果有漫游标签，则查询漫游套餐
                if(this.allTagList.some(item => item.tagKey === 'ROAMING' )){
                    // this.getRoamingPackageList();
                    RoamingPackageList.forEach(item => {
                        if(item.extendValVos && item.extendValVos.length){
                            item.extendValVos.forEach(extend => {
                                this.regionList.forEach(region => {
                                    if(extend.attrCode === region.key){
                                        item.areaName = region.value;
                                    }
                                });
                            })
                        }
                    })

                    // 分类套餐
                    this.allTagList.some(item => {
                        if(item.tagKey === 'ROAMING' && RoamingPackageList.length){
                            let list = this.handlerClassify(RoamingPackageList);
                            this.packageGroupList.push({
                                value: item.tagKey,
                                label: item.tagName,
                                list,
                            });
                            return true;
                        }
                    })

                    this.selectValueList[0] =  this.packageGroupList[0].value;
                    this.selectValueList[1] =  this.packageGroupList[0].list[0].value;
                    this.selectValueList[2] =  this.packageGroupList[0].list[0].list[0].value;
                    this.selectValueList[3] =  this.packageGroupList[0].list[0].list[0].list[0].goodsCode;
                    this.selectValue = this.packageGroupList[0].list[0].list[0].list[0];
                    
                    // this.setOneTabLeft();

                } else {
                    this.selectValueList[0] = this.packageGroupList[0]?.value;
                    this.selectValueList[1] = this.packageGroupList[0].list[0].value;
                    this.selectValueList[2] = this.packageGroupList[0].list[0].list[0].value;
                    this.selectValueList[3] = this.packageGroupList[0].list[0].list[0].list[0].goodsCode;
                    this.selectValue = this.packageGroupList[0].list[0].list[0].list[0];

                    // this.setOneTabLeft();
                }
            // }).catch(err => {
            //     this.$toast(err);
            //     console.log(err);
                
            // });
        },
        // 处理分类
        handlerClassify(packList){
            let list = [];
            let pkList = [];
            let dsList = [];
            packList.forEach(pkg => {
                if(pkg.goodsType === 'PKAG'){
                    if(pkList.some(pk => pk.value === pkg.showFlow)){
                        pkList.find(pk => pk.value === pkg.showFlow).list.push(pkg);
                    } else {
                        let aFlow = pkg.flowByte;
                        if(pkg.billingInfos && pkg.billingInfos.length){
                          aFlow = pkg.billingInfos[0].flow || pkg.flowByte;
                        }
                        pkList.push({
                            value: pkg.showFlow,
                            label: pkg.showFlow,
                            aFlow,
                            list: [pkg],
                            isUnLimit: pkg.isUnLimit,
                        });
                    }
                } else {
                    if(dsList.some(ds => ds.value === pkg.showFlow)){
                        dsList.find(ds => ds.value === pkg.showFlow).list.push(pkg);
                    } else {
                        let aFlow = pkg.flowByte;
                        if(pkg.billingInfos && pkg.billingInfos.length){
                          aFlow = pkg.billingInfos[0].flow || pkg.flowByte;
                        }
                        dsList.push({
                            value: pkg.showFlow,
                            label: pkg.showFlow,
                            aFlow,
                            list: [pkg],
                            isUnLimit: pkg.isUnLimit,
                        });
                    }
                }
            });
            if(dsList.length){
                // 流量大小排序
                dsList = dsList.sort((a,b) => {
                    let aFlow = a.aFlow;
                    let bFlow = b.aFlow;
                    if(a.isUnLimit){
                        aFlow = Number.MAX_SAFE_INTEGER;
                    }
                    if(b.isUnLimit){
                        bFlow = Number.MAX_SAFE_INTEGER;
                    }
                    return bFlow - aFlow
                });
                // 套餐时间排序
                dsList.forEach(item => {
                    item.list = item.list.sort((a,b) => {
                        let aPeriod;
                        let bPeriod;
                        aPeriod = aPeriod ? aPeriod : (a.periodUnit === "DAY" ? +a.periodNum : +a.periodNum * 30);
                        bPeriod = bPeriod ? bPeriod : (b.periodUnit === "DAY" ? +b.periodNum : +b.periodNum * 30);
                        if(['LXCX'].includes(a.categoryCode) && a.payAgreeFlag == '1'){
                            aPeriod = aPeriod + 0.5;
                        }
                        if(['LXCX'].includes(b.categoryCode) && b.payAgreeFlag == '1'){
                            bPeriod = bPeriod + 0.5;
                        }
                        return bPeriod - aPeriod;
                    });
                });
                list.push({
                    value: 'DISC',
                    label: this.$t('select_package.month_package'),
                    list:dsList,
                });
            }
            if(pkList.length){
                // 流量大小排序
                pkList = pkList.sort((a,b) => {
                    let aFlow = a.aFlow;
                    let bFlow = b.aFlow;
                    if(a.isUnLimit){
                        aFlow = Number.MAX_SAFE_INTEGER;
                    }
                    if(b.isUnLimit){
                        bFlow = Number.MAX_SAFE_INTEGER;
                    }
                    return bFlow - aFlow
                });
                // 套餐时间排序
                pkList.forEach(item => {
                    item.list = item.list.sort((a,b) => {
                        let aPeriod;
                        let bPeriod;
                        aPeriod = aPeriod ? aPeriod : (a.periodUnit === "DAY" ? +a.periodNum : +a.periodNum * 30);
                        bPeriod = bPeriod ? bPeriod : (b.periodUnit === "DAY" ? +b.periodNum : +b.periodNum * 30);
                        if(['LXCX'].includes(a.categoryCode) && a.payAgreeFlag == '1'){
                            aPeriod = aPeriod + 0.5;
                        }
                        if(['LXCX'].includes(b.categoryCode) && b.payAgreeFlag == '1'){
                            bPeriod = bPeriod + 0.5;
                        }
                        return bPeriod - aPeriod;
                    });
                });
                list.push({
                    value: 'PKAG',
                    label: this.$t('select_package.flow_package'),
                    list:pkList,
                });
            }
            return list;
        },
        initLocalPackageData(list) {                
            let newList = [];

            for(let i = 0;i < list.length;i++) {                    
                let item  = list[i];
                item.goodsPrice = +item.goodsPrice + "";

                // 页面只显示DISC、PKAG
                if(item.goodsType != 'DISC' && item.goodsType != 'PKAG') {
                    continue;
                }
                // 过滤黑名单
                if(item.mccFlag && item.mccFlag == 'BLACK') {
                    continue;
                }
                // 过滤掉用户自定义
                if(item.attrMap.effType == 'USER_DEFINED') {
                    continue;
                }
                // 过滤掉DIY
                if((item.goodsType == 'DISC' && item.categoryCode == 'GDIY') || (item.goodsType == 'PKAG' && item.attrMap.pkType == 'DIY')) {
                    continue;
                }
                // 过滤掉CZME
                if(item.categoryCode && item.categoryCode == 'CZME') {
                    continue;
                }
                // 过滤DSDS
                /*
                if(item.terminalType == 'DSDS') {
                    continue;
                }
                */
                
                // item.item_bg = unlimited_bg;
                // if(item.goodsType == 'DISC') {
                //     item.item_bg = unlimited_bg;
                // } else if(item.goodsType == 'PKAG') {
                //     item.item_bg = normal_bg;
                // }

                item.periodNum = item.period;
                
                // 处理价格
                item.listPriceShow = false;
                item.vipPriceShow = false;
                if(item.payAgreeFlag == "1" && item.deductionInfo != null && item.deductionInfo.autoRenewActCode != null) {
                    // vip会员日并且最低价是discountPrice
                    if(item.vipAct && item.vipAct === '1' && this.minPriceIsDiscountPrice(item)) {
                        this.doPriceStyle(item, item.goodsPrice, 'goodsPriceText');
                        this.doPriceStyle(item, item.discountPrice, 'vipPrice');
                        item.vipPriceShow = true;
                    } else {
                        let autoRenewFirstPrice = item.deductionInfo.autoRenewFirstPrice ? item.deductionInfo.autoRenewFirstPrice : 0.0;
                        if(autoRenewFirstPrice > 0 && autoRenewFirstPrice < item.goodsPrice) {
                            this.doPriceStyle(item, this.getMinPrice(item), 'goodsPriceText');
                            item.listPriceShow = true;
                            this.doPriceStyle(item, item.goodsPrice, 'listPrice');
                        } else {
                            this.doPriceStyle(item, this.getMinPrice(item), 'goodsPriceText');
                        }
                    }
                } else {
                    // vip 会员日
                    if(item.vipAct && item.vipAct === '1') {
                        this.doPriceStyle(item, item.goodsPrice, 'goodsPriceText');
                        this.doPriceStyle(item, item.discountPrice, 'vipPrice');
                        item.vipPriceShow = true;
                    } else {
                        this.doPriceStyle(item, item.discountPrice !== null ? item.discountPrice : item.goodsPrice, 'goodsPriceText');
                        if(item.discountPrice != null) {
                            this.doPriceStyle(item, item.goodsPrice, 'listPrice');
                            item.listPriceShow = true;
                        }
                    }
                }

                item.showUserDetail = item.attrMap.pkDesc;
                item.showUserRemark = item.attrMap.remark;
                //复用流量商城原始方法获取地区
                item.showAreaList = item.mccList.join(', ');

                // 原价
                this.doPriceStyle(item, item.goodsPrice, 'originalPrice');

                // 计算优惠券后的价格
                this.e_preCalcOrder(item);

                // 格式化价格，拆分为整数和小数
                if(item.goodsPriceText) {
                    let lowerCurrency = item.currencyType.toLowerCase();
                    let codeType = this.$APP_CONFIG.currencyTypeMap[lowerCurrency] ? this.$APP_CONFIG.currencyTypeMap[lowerCurrency] : item.currencyType;
                    item.priceCurrencyType = codeType;
                    let price = item.goodsPriceText.split(item.currencyType)[1];
                    if(!price && this.$APP_CONFIG.currencyTypeMap[item.currencyType.toLowerCase()]){
                        price = item.goodsPriceText.split(this.$APP_CONFIG.currencyTypeMap[item.currencyType.toLowerCase()])[1];
                    }
                    let priceParts = price.split('.');
                    // 保存一下数据
                    item.goodsPriceNum = price && price.replace(',','.');
                    if(priceParts.length >= 2){
                        item.goodsIntPrice = priceParts[0].trim();
                        item.goodsDecimalPrice = +priceParts[1] === 0 ? '' : this.formatStringNumber(priceParts[1]);
                        item.pricePunctuation =  item.goodsDecimalPrice ? '.' : '';
                    } else {
                        item.goodsIntPrice = price.split(',')[0].trim();
                        item.goodsDecimalPrice = +price.split(',')[1]  === 0 ? '' :  this.formatStringNumber(price.split(',')[1]);
                        item.pricePunctuation = item.goodsDecimalPrice ? ',' : '';
                    }
                }
                //生成角标
                this.genSaleIcon(item);

                // 流量大小
                item.showFlow = this.doFlowByteText(item);
                item.showPeriod = this.getValidityPeriod(item);
                item.isShowPriceUnit = true;

                item.isShowPeriod = true;
                
                // 获取隐藏流量大小扩展属性值，用于展示无限流量，2 - 无限流量
                if(item.extendValVos && item.extendValVos.length){
                    let isUnLimit = item.extendValVos.some(extend => {
                        if(extend.attrCode === 'hideFlowSize' && extend.attrValueList.includes('2')) {
                            return true;
                        }
                    })
                    if(isUnLimit) {
                        item.showFlow = this.$t('packages.unLimitData');
                        item.isUnLimit = true;
                    }
                }
                
                // multi region packages
                if(item.iso2List && (item.iso2List.length > 1 || item.iso2List[0] == 'ALL')) {                 
                    item.multiRegionFlag = true;
                } else if (item.goodsType == 'DISC') {
                    if (['BYTC', 'SWBY', 'BTTC', 'LXCX'].includes(item.categoryCode)) {
                        item.unlimitedFlag = true;
                        this.doUnlimitedPackages(item);
                    }
                } else if(item.goodsType == 'PKAG') {
                    if(item.attrMap.pkType != 'DIY') {
                        item.normalFlag = true;
                        this.doNormalPackages(item)
                    }
                }
                if(item.periodUnit === 'MONTH' && item.period > 1){
                    item.showBottomtips = '≈' + this.globalPriceFormat(item.currencyType,(item.goodsPriceNum / +item.period).toFixed(2) * 100) + `/${this.getUnitOfTime(item.periodUnit,1)}`;                    
                }
                if(item.categoryCode === 'LXCX' && item.payAgreeFlag == '1'){
                    // 底部内容用于显示自动续订说明
                    item.showBottomtips = this.$t('select_package.auto_subscribe');
                    this.handlerLXCXPackage(item);
                }

                newList.push(item);
            }
            
            return newList;
        },
        // 计算优惠券后的价格
        e_preCalcOrder(item) {
            if(['LXCX'].includes(item.categoryCode) && item.payAgreeFlag == '1') return;
            let couponList = JSON.parse(sessionStorage.getItem('data-couponList') || "[]");
            let promotionCode = '';
            let cutPrice = couponList.reduce((prev, curr) => {
                let cutPrice = 0;
                if(curr.goodsList.includes('ALL') || curr.goodsList.includes(item.goodsId)){
                    if(['P01','P03'].includes(curr.promotionMode)){
                        cutPrice = (+item.goodsPrice) * (curr.quota / 100);
                    } else {
                        cutPrice = curr.quota * 100;
                    }

                    if(['P01','P02'].includes(curr.promotionMode) && +item.goodsPrice < +curr.fullCut * 100){
                        cutPrice = 0
                    }
                }

                if(prev > cutPrice) {
                    return prev;
                } else {
                    promotionCode = curr.promotionCode;
                    return cutPrice;
                }
            }, 0);

            let finalPrice = +item.goodsPrice - cutPrice;
            if(finalPrice >= 0 && finalPrice < this.getMinPrice(item)) {
                this.doPriceStyle(item, finalPrice, 'goodsPriceText');
                item.promotionCode = promotionCode;
            } else if(finalPrice < 0) {
                this.doPriceStyle(item, 0, 'goodsPriceText');
                item.promotionCode = promotionCode;
            }
        },
        // 处理LXCX套餐
        handlerLXCXPackage(tempData){
            let html = '' ;
            let preCalcOrder ;
            let that = this;
            tempData.periodStr = (tempData.billingInfos && tempData.billingInfos[0]) ?  this.moOrDay(tempData.billingInfos[0]) : '' ;
            //处理连续包月套餐
            tempData.select = true ;
            tempData.periodTxt = tempData.periodUnit == 'MONTH' ? this.$t('packages.continuousMonth') : this.$t('packages.continuousDay');
            html += '<p class="se_title">' + tempData.periodTxt +'</p>';
            if(tempData.deductionInfo){
                tempData.firstPrice = tempData.deductionInfo.autoRenewFirstPrice < tempData.deductionInfo.autoRenewPrice ?tempData.deductionInfo.autoRenewFirstPrice : '';
                tempData.oringPrice =  tempData.goodsPrice ;
                tempData.goodsPrice = tempData.deductionInfo.autoRenewPrice < parseInt(tempData.goodsPrice) ? tempData.deductionInfo.autoRenewPrice : tempData.goodsPrice ;
                tempData.goodsPrice = preCalcOrder ? preCalcOrder.data.payPrice : tempData.goodsPrice ;
                if(tempData.firstPrice){
                    //有预计算就显示预计算价格
                    let realprice = preCalcOrder ? that.globalPriceFormat(tempData.currencyType,preCalcOrder.
                        data.payPrice) : that.globalPriceFormat(tempData.currencyType,tempData.firstPrice) ;

                    html += '<p class="se_content">'+that.$t('orderTips.First_charge_discount') + '</p>';

                    html = html.replace('%@firstMoney',that.globalPriceFormat(tempData.currencyType,tempData.firstPrice)).replace('%@money',that.globalPriceFormat(tempData.currencyType,tempData.deductionInfo.autoRenewPrice)).replace(new RegExp('%@periodSymbol',"g"),tempData.periodStr);
                    
                    html += '<p class="se_package_price">'+realprice+'   <i class="oprice">'+that.globalPriceFormat(tempData.currencyType,tempData.oringPrice) +'</i></p>';
                    tempData.firstShowPrice =  realprice;
                }else{ //不存在首次优惠则计算和普通包月差价
                    if(tempData.oringPrice > tempData.goodsPrice){
                        tempData.savePrice = parseInt(tempData.oringPrice) - parseInt(tempData.goodsPrice);

                        html += '<p class="se_content">'+that.$t('orderTips.Monthly_discount') + '</p>';

                        html = html.replace('%@saveMoney',that.globalPriceFormat(tempData.currencyType,tempData.savePrice)).replace('%@period',tempData.periodStr);

                        html += '<p class="se_package_price">'+that.globalPriceFormat(tempData.currencyType,tempData.goodsPrice)+'  <i class="oprice">'+that.globalPriceFormat(tempData.currencyType,tempData.oringPrice)+'</i></p>';
                    }else{
                        html += '<p class="se_content">'+ that.$t('detail_se_content') + '</p>';
                        html += '<p class="se_package_price">'+that.globalPriceFormat(tempData.currencyType,tempData.goodsPrice)+'</p>';
                    }
                }   
            }else{

                html += '<p class="se_content">' + that.$t('detail_se_content') +'</p>';
                html += '<p class="se_package_price">'+that.globalPriceFormat(tempData.currencyType,tempData.goodsPrice)+'</p>';
            }
            
            tempData.continue_html = html;
        },
        //moOrDay 的功能 与genHighSeepText 一致
        //新老版本使用方法不同，保留genHighSeepText方法 
        moOrDay(data){
            var str = "";
            if(data.periodUnit == 1){
            if(data.period>1){
                str = data.period+this.$t('packages.periodUnits.day');
            }else{
                str = this.$t('packages.periodUnit.day');
            }

            }else if(data.periodUnit == 2 || data.periodUnit == 12){
                if(data.period>1){
                    str = data.period+this.$t('packages.periodUnitsSimp.month');
                }else{
                    str = this.$t('packages.periodUnitSimp.month');
                }
            }else if(data.periodUnit == 0){
                if(data.period>1){
                    str = data.period+this.$t('packages.periodUnits.hour');
                }else{
                    str = this.$t('packages.periodUnit.hour');
                }
            }else if(data.periodUnit == 3){
                if(data.period>1){
                    str = data.period+this.$t('packages.periodUnits.year');
                }else{
                    str = this.$t('packages.periodUnit.year');
                }
            }else{
                str = '';
            }
            return str;
        
        },
        // 处理年套餐每月金额问题
        getUnitOfPrice(price, num){
            if(!price) return '';
            let priceNum = price.replace(/,/g, ''); // 去掉价格中的逗号

            const result = priceNum / +num;
            const rounded = Math.round(result * 10) / 10; // 四舍五入到一位小数
            
            // 检查是否是整数（考虑浮点数精度）
            if (Math.abs(rounded - Math.round(rounded)) < 0.0001) {
                return Math.round(rounded).toString();
            }
            return rounded.toString();
        },
        // 处理小数位问题
        formatStringNumber(str) {
            // 如果字符串以'0'开头，直接返回原字符串
            if (str.startsWith('0')) {
                return str;
            }
            
            // 将字符串转换为数字，然后去除末尾的零
            let num = parseInt(str, 10);
            
            // 不断除以10直到不能整除
            while (num > 0 && num % 10 === 0) {
                num = Math.floor(num / 10);
            }
            
            return num.toString();
        },
        // 处理高速流量单位
        handlerBillingInfo(item) {
            let text = '';
            if(item.billingInfos && item.billingInfos.length) {
                let billingInfo = item.billingInfos[0];
                if(billingInfo.periodUnit == 0) {
                    if(billingInfo.period > 1){
                        text = this.$t('packages.periodUnits.hour');
                    } else {
                        text = this.$t('packages.periodUnit.hour');
                    }
                } else if(billingInfo.periodUnit == 1) {
                    if(billingInfo.period > 1){
                        text = this.$t('packages.periodUnits.day');
                    } else {
                        text = this.$t('packages.periodUnit.day');
                    }
                } else if(billingInfo.periodUnit == 2 || billingInfo.periodUnit == 12) {
                    if(billingInfo.period > 1){
                        text = this.$t('packages.periodUnits.month');
                    } else {
                        text = this.$t('packages.periodUnitMonthly');
                    }
                } else if(billingInfo.periodUnit == 3) {
                    if(billingInfo.period > 1){
                        text = this.$t('packages.periodUnits.year');
                    } else {
                        text = this.$t('packages.periodUnit.year');
                    }
                }
            }
            return text;
        },
        // 处理流量大小显示
        doFlowByteText(item) {
            let flowText = '0MB',
                flowValue = item.billingInfos && item.billingInfos.length ? item.billingInfos[0].flow : (item.flowByte ? item.flowByte : 0);                    

            if(flowValue >= 1000) {
                let flow = flowValue/1024;
                // 判断是不是整数
                if(Math.floor(flow) === flow) {
                    flowText = `${flow}GB`;
                } else {
                    let langType = cookie.getCookie('langType')
                    // 部分欧洲国家小数点采取 ， 形式
                    let country = ['es-ES','pt-PT','de-DE','fr-FR']; 
                    let showFlow = keepTwodecimalFixed(flow)
                    if(country.includes(langType)){
                        showFlow = showFlow.replace('.',',')
                    }
                    flowText = `${showFlow}GB`;
                }
            } else {
                flowText = `${flowValue}MB`;
            }

            return flowText;        
        },
        //连续包月增加--20241205--start
        getValidityPeriod (a) {
            // 有效期
            let periodTxt = '';

            if (a.attrMap.expType && (a.attrMap.expType == 'CURRENT_MONTH' || a.attrMap.expType == 'CURRENT_DAY')) {
                periodTxt = this.getTypeOfFailures(a);      // 失效类型
            } else {
                if (a.period == null || a.period == '') {
                    periodTxt = '';
                } else {
                    let actionType = this.getEffectiveType (a);     // 生效类型
                    periodTxt = a.period +' '+ this.getUnitOfTime (a.periodUnit, a.period) + ' ' + actionType;
                }
            }
            return periodTxt;
        },
        getTypeOfFailures (a) {
            // 失效类型
            let actionType = '';

            if (a != null && a != '' && a.attrMap.expType) {
                if (a.attrMap.expType == 'CURRENT_MONTH') {
                    actionType = this.$t('packages.month_invalid');
                } else if (a.attrMap.expType == 'CURRENT_DAY') {
                    actionType = this.$t('packages.day_invalid');
                } else if (a.attrMap.expType == 'DEFAULT') {
                    actionType = '';
                } else {
                    actionType = '';
                }
            }
            return  actionType;
        },
        getEffectiveType (a) {
            // 生效类型
            let actionType = '';

            if (a != null && a != '' && a.attrMap.effType) {
                if (a.attrMap.effType == 'IMMEDIATELY') {
                    a.period == null || a.period == '' ? actionType = this.$t('packages.immediate_valid') : actionType = ''

                } else if (a.attrMap.effType == 'MORROW') {
                    a.period == null || a.period == '' ? actionType = this.$t('packages.tomorrow_day_valid') : actionType = '';

                } else if (a.attrMap.effType == 'USER_DEFINED') {
                    actionType = '';

                } else if (a.attrMap.effType == 'NEXT_MONTH') {
                    a.period == null || a.period == '' ? actionType = this.$t('packages.tomorrow_month_valid') : actionType = '';

                } else {
                    actionType = '';
                }
            }
            return actionType;
        },
        getUnitOfTime (a, b) {
            let unit = a;

            if (unit == 'DAY' || unit == null || unit == '') {
                if (parseInt(b) < 2 || b == null || b =='') {
                    unit = this.$t('packages.periodUnit.day');
                } else {
                    unit = this.$t('packages.periodUnits.day');
                }
            } else if (unit == 'MONTH') {
                if (parseInt(b) < 2 || b == null || b =='') {
                    unit = this.$t('packages.periodUnit.month');
                } else {
                    unit = this.$t('packages.periodUnits.month');
                }
            }
            return unit;
        },
        genSaleIcon(item) {
            /*
                * sale icon
                * */
            item.saleTextShow = false;
            item.saleIconShow = false;
            let _w = 'auto';
            if(isAndroid()) {
                /*
                if(Math.floor(window.devicePixelRatio) == 1) {
                    _w = `${100/3}%`
                } else if(Math.floor(window.devicePixelRatio) == 2 || Math.floor(window.devicePixelRatio) == 3) {
                    _w = `${(100*2)/3}%`;
                }
                */
            } else {
                if(Math.floor(window.devicePixelRatio) == 1) {
                    _w = `${100/3}%`
                } else if(Math.floor(window.devicePixelRatio) == 2) {
                    _w = `${(100*2)/3}%`;
                }
            }
            item.saleIconStyle = {
                width: _w
            };
            let saleImageUrl = '';
            // 获取图标
            if(item.cornerMark != null && Object.values(item.cornerMark).length > 0 && Object.values(item.cornerMark).some(val => val != '')) {
                if(item.payAgreeFlag == "1" && item.deductionInfo != null && item.deductionInfo.autoRenewActCode != null) {
                    saleImageUrl = item.cornerMark[item.deductionInfo.autoRenewActCode];
                } else {
                    saleImageUrl = item.cornerMark[item.promotionActivityCode];
                }
            } else if(item.iconInfos && item.iconInfos.length > 0) {
                saleImageUrl = item.iconInfos[0].attrValue;
            }
            // 判断图标是否为空
            if(saleImageUrl) {
                item.saleImageUrl = saleImageUrl;
                item.saleIconShow = true;
            }
            let img = new Image(),iconStyle = {};
            img.addEventListener('load', () => {
                if(img.width >= this.boxItemWidth) {
                    iconStyle = {width: '100%'};
                } else {
                    iconStyle = {width: 'auto'};
                }
                this.$set(item,'iconStyle',iconStyle);
            },false)

            if(item.saleImageUrl){
                img.src = item.saleImageUrl;    
            }
            
        },
        doNormalPackages(item) {
            this.genName(item);
            this.doNormalPackagesCycle(item);
        },
        //处理普通包有效期
        doNormalPackagesCycle(item) {
            let expireToday = item.goodsType != 'DISC' && item.attrMap.expType == 'CURRENT_DAY',
                expireThisMonth = item.goodsType != 'DISC' && item.attrMap.expType == 'CURRENT_MONTH',
                effectiveImmediately = item.goodsType == 'DISC' && item.attrMap.effType == 'IMMEDIATELY',
                effectiveMarrow = item.goodsType == 'DISC' && item.attrMap.effType == 'MARROW',
                effectiveNextMonth = item.goodsType == 'DISC' && item.attrMap.effType == 'NEXT_MONTH';

            if(expireToday || expireThisMonth) {
                item.period = expireToday ? `${this.$t('packages.day_invalid')}` : `${this.$t('packages.month_invalid')}`
            } else {
                if(item.period) {
                    let singleUnit = this.$t(`packages.periodUnit.${item.periodUnit.toLowerCase()}`),
                        multipleUnit = this.$t(`packages.periodUnits.${item.periodUnit.toLowerCase()}`);
                    item.period = item.period > 1 ? `${item.period} ${multipleUnit}` : `${item.period} ${singleUnit}`;
                    if(effectiveImmediately) {
                        item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t('packages.immediate_valid')})` : `${item.period} ${singleUnit}(${this.$t('packages.immediate_valid')})`;
                    } else if(effectiveMarrow) {
                        item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t('packages.tomorrow_day_valid')})` : `${item.period} ${singleUnit}(${this.$t('packages.tomorrow_day_valid')})`;
                    } else if(effectiveNextMonth) {
                        item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t('packages.tomorrow_month_valid')})` : `${item.period} ${singleUnit}(${this.$t('packages.tomorrow_month_valid')})`;
                    }
                }
            }
        },
        doUnlimitedPackages(item) {
            this.genName(item);
            // 0为按小时取，1为按天取，2为按月取，3为按年取，12为动态月也是按月取同2
            item.high_speed_text = this.$t('packages.high_speed_text');
            let billInfo = item.billingInfos;
            if(billInfo && billInfo.length > 0) {
                if(billInfo[0].periodUnit === 0) {
                    if(item.period == billInfo[0].period && item.periodUnit == 'HOUR') {
                        item.high_speed_text = this.$t('packages.high_speed_text');
                    } else {
                        if(billInfo[0].period > 1) {
                            item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.hour')
                        } else {
                            item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.hour')
                        }
                    }

                } else if(billInfo[0].periodUnit === 1) {
                    if(item.period == billInfo[0].period && item.periodUnit == 'DAY') {
                        item.high_speed_text = this.$t('packages.high_speed_text');
                    } else {
                        if(billInfo[0].period > 1) {
                            item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitSimp.day')
                        } else {
                            item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.day')
                        }
                    }

                } else if(billInfo[0].periodUnit === 2 || billInfo[0].periodUnit === 12) {
                    if(item.period == billInfo[0].period && item.periodUnit == 'MONTH') {
                        item.high_speed_text = this.$t('packages.high_speed_text');
                    } else {
                        if(billInfo[0].period > 1) {
                            item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.month')
                        } else {
                            item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.month')
                        }
                    }
                } else if(billInfo[0].periodUnit === 3) {
                    if(item.period == billInfo[0].period && item.periodUnit == 'YEAR') {
                        item.high_speed_text = this.$t('packages.high_speed_text');
                    } else {
                        if(billInfo[0].period > 1) {
                            item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.year')
                        } else {
                            item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.year')
                        }
                    }
                }
            }

            if(item.categoryCode == 'BTTC' || (item.categoryCode == 'LXCX' && item.periodUnit == 'DAY')) {
                item.goodsNameStr = this.$t('packages.unlimited_good_name.day');

            } else if (item.categoryCode == 'BYTC' || item.categoryCode == 'SWBY' || (item.categoryCode == 'LXCX' && item.periodUnit == 'MONTH')) {
                if(item.period && item.period == 12) {
                    item.goodsNameStr = this.$t('packages.unlimited_good_name.year');
                } else {
                    if(item.attrmap && item.attrmap.period && item.attrmap.period == 12) {
                        item.goodsNameStr = this.$t('packages.unlimited_good_name.year');
                    } else {
                        item.goodsNameStr = this.$t('packages.unlimited_good_name.month');
                    }
                }
            }
        },
        genName(item) {
            let flow = (item.billingInfos && item.billingInfos.length > 0) ? item.billingInfos[0].flow : item.flowByte;
            if(flow > 0) {
                if(flow > 1000) {
                    flow = flow/1024;
                    // 判断是不是整数
                    if(Math.floor(flow) === flow) {
                        item.goodsName_H5_tag = `${flow}GB`;
                    } else {
                        item.goodsName_H5_tag = `${keepTwodecimalFixed(flow)}GB`;
                    }
                } else {
                    item.goodsName_H5_tag = `${flow}MB`;
                }
            } else {
                item.goodsName_H5_tag = `0MB`;
            }
        },
        getMinPrice(item) {
            let prices = [];

            if(item.deductionInfo?.autoRenewFirstPrice) {
                prices.push(item.deductionInfo.autoRenewFirstPrice);
            }
            if(item.deductionInfo?.autoRenewPrice) {
                prices.push(item.deductionInfo.autoRenewPrice);
            }
            if(item.discountPrice) {
                prices.push(item.discountPrice);
            }
            if(item.goodsPrice) {
                prices.push(item.goodsPrice);
            }

            return Math.min(...prices);
        },
        doPriceStyle(item, price, key) {
            //price = keepTwodecimalFull(price/100);
            //item[key] = `${item.currencyType} ${price}`;
            item[key] = this.globalPriceFormat(item.currencyType, price);                
        },
        minPriceIsDiscountPrice(item) {
            let autoRenewFirstPrice = item.deductionInfo.autoRenewFirstPrice ? item.deductionInfo.autoRenewFirstPrice : 0.0;
            let autoRenewPrice = item.deductionInfo.autoRenewPrice ? item.deductionInfo.autoRenewPrice : 0.0;
            let discountPrice = item.discountPrice ? item.discountPrice : 0.0;
            if(autoRenewPrice > discountPrice && autoRenewFirstPrice > discountPrice) {
                return true;
            }
            return false;
        },
    }
}
</script>

<style lang="less" scoped>
.select-package {
    // min-height: 100vh;
    // min-height: 100dvh;
    min-height: 100%;
    background-color: #f2f2f2;
    overflow-y: auto;
    .home-package {
        margin-top: 10px;
        margin-left: 10px;
        margin-right: 10px;
        background-color: #fff;
        padding: 16px;
        border-radius: 8px;
        box-shadow: 0 1px 2px 0 rgba(0, 0 ,0 , 0.05);
        position: relative;
        overflow: hidden;
        .home-package-bg {
            position: absolute;
            top: 0;
            right: 0;
            width: 10em;
            height: 10em;
            pointer-events: none;
            background-color: rgba(22, 93, 255, 0.05);
            border-bottom-left-radius: 9999px;
        }
        .home-package-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .title {
                font-family: SourceHanSansCN-Normal;
                font-size: 14px;
                color: #333333;
                font-weight: 600;
            }
            .manage-package {
                // border-radius: 8px;
                // border: 1px solid #165dff;
                color: #165dff;
                // background-color: #fff;
                font-size: 14px;
                // padding: 6px 10px;
            }
        }
        .home-package-con {
            font-size: 12px;
            position: relative;
            .mt10 {
                margin-top: 10px;
            }
            .package-name {
                font-size: 14px;
                font-weight: normal;
                font-family: SourceHanSansCN-Normal;
            }
            .state-tips {
                position: absolute;
                right: 0;
                bottom: 0;
                display: block;
                padding: 2px 8px;
                border-radius: 12px;
                color: #165dff;
                background-color:rgba(22, 93 ,255, 0.1);
                font-size: 10px;
            }
        }
        .home-package-no-con {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 106px;
            font-size: 14px;
            color: #4361ee;
        }
    }
    .my-nav-bar {
        min-height: 70px;
        margin-left: 10px;
        margin-right: 10px;
        background: #FFFFFF;
        box-shadow: 0 6px 10px 0 rgba(0,0,0,0.02);
        border-radius: 8px;
        margin-top: 10px;
        position: relative;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-auto-rows: auto auto;
        place-items: center;
        .line {
            height: 60px;
            width: 1px;
            background: #E0E0E0;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%) scaleX(0.5);            
        }
        .item {              
            flex: 1;
            text-align: center;
            font-family: SourceHanSansCN-Normal;
            font-size: 14px;
            color: #4A4A4A;
            img {
                width: 32px;
                height: 32px;
            }
            .name {
                // margin-top: 5px;
            }
        }
        .module-coupons {
            .coupons-img-count {
                position: relative;
                display: inline-block;
                .coupons-count {
                    height: 12px;
                    line-height: 12px;
                    text-align: center;
                    padding: 0 6px;
                    background: #F74E4E;
                    position: absolute;
                    top:  0;
                    right: -20px;
                    color: #fff;
                    border-radius: 8px;
                    min-width:26px;
                    font-size: 10px;
                }
            }
        }
        .line-site {
            top: 25%;
        }
    }
    .select-package-con {
        // min-height: calc(100vh - 48px);
        // min-height: calc(100dvh - 48px);
        min-height: calc(100% - 48px);
        ::v-deep {
        .van-tabs-con {
            .van-tabs__nav {
                justify-content: start;
                padding-left: 10px;
                .van-tab {
                    justify-content: start;
                }
                .van-tabs__line {
                    // transform: translateX(10px) !important;
                }
            }
        }
      }
      .select-package-item-con {
        padding: 0 10px 20px;
        .type-title {
            font-size: 15px;
            font-weight: 600;
            margin-top: 13px;
            margin-bottom: 8px;
        }
        .package-type-item-con {
            width: calc(100%);
            display: flex;
            width: 100%;
            gap: 10px;
            padding-top: 2px;
            padding-bottom: 4px;
            // display: grid;
            // grid-auto-flow: column; /* 横向排列 */
            // /** 宽度是三等分，超过三个横向滚动 */
            // grid-auto-columns: calc((100% - 20px) / 3); /* 默认三等分 */
            // gap: 10px;
            margin-top: 5px;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch; /* 提升移动端滚动体验 */
            -ms-overflow-style: none;  /* IE/Edge */
            scrollbar-width: none;     /* Firefox */
            &::-webkit-scrollbar {
                display: none; /* Chrome/Safari/Webkit */
            }
            .package-type-item {
                min-width: calc((100% - 20px) / 3);
                flex-shrink: 0;
            }
        }
        .package-type-item {
            height: 32px;
            background-color: #fff;
            border-radius: 6px;
            font-size: 12px;
            color: #3D3D3D;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            padding: 2px 0;
            border: 1px solid transparent;
        }
        .active {
            border: 1px solid #4361EE !important;
            color: #4361EE;
        }
        .package-type-pack-con {
            // border-bottom: 1px solid #ccc;
            overflow: hidden;
            border-radius: 4px;
            margin-top: 8px;
        }
        .package-type-pack-title {
            position: relative;
            font-size: 14px;
            height: 25px;
            line-height: 25px;
            width: max-content;
            padding: 0 8px;
            background-color: #ccc;
            border-radius: 4px;
            z-index: 2;
        }
        .package-bg-img {
            position: absolute;
            right: calc(50px - 100vw);
            top: 0;
            width: 100vw;
            height: 25px;
            z-index: -1;
        }
        .flow-data {
            //**一行放置4个, 放不下的时候就换行 */ 
            margin-top: 8px;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 10px;
        }
        .package-list {
            display: flex;
            width: 100%;
            gap: 10px;
            margin-left: -3px;
            padding-left: 6px;
            padding-top: 6px;
            padding-bottom: 2px;
            margin-top: -6px;
            box-sizing: border-box;
            // flex-wrap: wrap;
            // grid-auto-flow: column; /* 横向排列 */
            // /** 宽度是三等分，超过三个横向滚动 */
            // grid-auto-columns: calc((100% - 20px) / 3); /* 默认三等分 */
            -ms-overflow-style: none;  /* IE/Edge */
            scrollbar-width: none;     /* Firefox */
            &::-webkit-scrollbar {
                display: none; /* Chrome/Safari/Webkit */
            }
            overflow-x: auto;
            // gap: 10px;
            .package-item {
                width: calc((100% - 12px) / 3);
                flex-shrink: 0;
                background-color: #fff;
                border-radius: 10px;
                padding: 12px 0 10px 0;
                border: 1px solid transparent;
                position: relative;
                .use_coupon_tips {
                    position: absolute;
                    color: #fff;
                    background-color: #ff4e4e;
                    font-size: 10px;
                    top: -6px;
                    left: -6px;
                    padding: 0px 3px;
                    min-width: 28px;
                    border-radius: 4px;
                    display: inline-block;
                    height: 16px;
                    line-height: 16px;
                }
                .package-time {
                    font-weight: 600;
                    font-size: 12px;
                    text-align: center;
                    color: #000;
                }
                .package-price {
                    font-variation-settings: "opsz" auto;
                    font-feature-settings: "kern" on;
                    font-size: 13px;
                    color: #F74E4E;
                    text-align: center;
                    margin-top: 20px;
                    margin-bottom: 20px;
                }
                .package-approx {
                    font-family: Source Han Sans;
                    font-size: 10px;
                    text-align: center;
                    color:rgba(0, 0, 0, 0.5);
                    min-height: 13px;
                }
            }
        }
        .auto-deduction-tips {
            border-radius: 5px;
            background-color: #fff;
            padding: 10px;
            ::v-deep {
                .se_title {
                    font-size: 15px;
                    font-weight: 600;
                    color: #000;
                }
                .se_content {
                    margin-top: 10px;
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.5);
                }
                .se_package_price {
                    display: none;
                }
            }
            .service-items {
                margin-top: 15px;
                color: #000;
                a {
                    color: #4361EE;
                }
                font-size: 11px;
            }
        }
        .package-details {
            margin-top: 13px;
            background-color: #fff;
            border-radius: 5px;
            padding-bottom: 40px;
            .title {
                font-size: 14px;
                font-weight: 600;
                text-align: center;
                background: linear-gradient(180deg, #97aaff 0%, rgba(123, 146, 238, 0) 80%);
                border-radius: 5px;
                height: 40px;
                line-height: 40px;
            }
            .package-detail-item {
                margin: 10px;
                font-size: 12px;
                font-weight: 600;
                display: flex;
                align-items: center;
                .tip {
                    display: inline-block;
                    width: 11px;
                    height: 11px;
                    margin-right: 6px;
                    background-color: #4361EE;
                }
            }
            .flex-between {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .package-detail-content {
                margin: 0 10px 0 10px;
                color: rgba(0, 0, 0, 0.5);
                font-size: 11px;
            }
        }
      }
    }
    .pay-btn-con {
        position: fixed;
        bottom: 10px;
        left: 0;
        right: 0;
        padding: 0 10px;
        display: flex;
        .pay-price {
            background-color: #000;
            color: #fff;
            font-size: 15px;
            font-weight: 600;
            font-variation-settings: "opsz" auto;
            font-feature-settings: "kern" on;
            flex: 2;
            height: 40px;
            line-height: 40px;
            padding-left: 15px;
            border-radius: 20px 0 0 20px;
        }
        .pay-btn {
            background-color: #4361EE;
            color: #fff;
            flex: 1;
            font-size: 15px;
            font-weight: 600;
            font-variation-settings: "opsz" auto;
            font-feature-settings: "kern" on;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border-radius: 0 20px 20px 0;
        }
    }
    .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding-top: 70px;
        img {
            width: 160px;
            height: 104px;
        }
        .tips-noData {
            font-weight: 700;
            font-size: 14px;
            margin-top: 14px;
        }
    }
}
html[dir="rtl"] .select-package {
    .select-package-con {
        .select-package-item-con {
                .package-bg-img {
                    left: calc(50px - 100vw);
                    right: unset;
                    top: 0;
                    // 左右反转
                    transform: scaleX(-1);
                }
                .package-details {
                    .package-detail-item {
                        .tip {
                            margin-right: unset;
                            margin-left: 6px;
                        }
                    }
                    .package-detail-content {
                        // margin-left: unset;
                        // margin-right: 10px;
                    }
                }
        }
    }
    .pay-btn-con {
        .pay-price {
            padding-left: unset;
            padding-right: 15px;
            border-radius: 0 20px 20px 0 ;
        }
        .pay-btn {
            border-radius: 20px 0 0 20px;
        }
    }
}
</style>